import Error404Guard from '@src/components/guard/Error404Guard';
import EventPreview from '@src/features/tenant/event/EventPreview';
import TenantPreviewLayout from '@src/layouts/tenant/TenantPreviewLayout';

function EventPreviewForm() {
  return (
    <Error404Guard isTenant={true}>
      <TenantPreviewLayout>
        <EventPreview />
      </TenantPreviewLayout>
    </Error404Guard>
  );
}
export default EventPreviewForm;
